export const formatPostnummer = (postnummer: string): string =>
  postnummer.length === 5
    ? `${postnummer.substring(0, 3)} ${postnummer.substring(3, 5)}`
    : postnummer;
